export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/future_bass.b0e8cc2.svg";